import html2pdf from "html2pdf.js";
import { getPdfOptions } from "helpers/pdfOptions";
import mainApi from "./mainApi";
import { getEnvVariables } from "../helpers/getEnvVariables";

const { BACK_BASE_URL } = getEnvVariables();

export const getDefaultFilename = (postData = {}) => {
  const name = postData?.name ?? "";
  const surname = postData?.surname ?? "";
  const fullName = `${name} ${surname}`.trim();

  return `${fullName || "quote"} VIP Care.pdf`;
};

export const getFilenameFromHeaders = (headers, fallbackFilename) => {
  const contentDisposition = headers?.["content-disposition"] ?? "";

  if (!contentDisposition) {
    return fallbackFilename;
  }

  const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8FilenameMatch?.[1]) {
    return decodeURIComponent(utf8FilenameMatch[1]);
  }

  const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);

  return filenameMatch?.[1] ?? fallbackFilename;
};

export const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = typeof reader.result === "string" ? reader.result : "";
      resolve(result.split(",")[1] ?? "");
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const downloadBlob = (blob, filename) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl);
  }, 1000);

  return objectUrl;
};

const buildPdfDocument = (response, postData) => {
  const fallbackFilename = getDefaultFilename(postData);
  const filename = getFilenameFromHeaders(response.headers, fallbackFilename);
  const blob = response.data instanceof Blob
    ? response.data
    : new Blob([response.data], { type: "application/pdf" });

  return { blob, filename };
};

export const getPdfDocumentWithData = async (postData) => {
  const response = await mainApi.post("/table-benefit/pdf", postData, {
    responseType: "blob",
  });

  return buildPdfDocument(response, postData);
};

export const getPdfAttachmentFromDocument = async ({ blob, filename }) => ({
  blob,
  filename,
  base64Content: await blobToBase64(blob),
});

export const getPdfAttachmentWithData = async (postData) => {
  const pdfDocument = await getPdfDocumentWithData(postData);

  return getPdfAttachmentFromDocument(pdfDocument);
};

export const getPdfAttachmentFromHtml = async (html, filename) => {
  const pdf = await html2pdf().from(html).set(getPdfOptions()).outputPdf();

  return {
    filename,
    base64Content: btoa(pdf),
  };
};

export const uploadPdfAttachment = async ({ filename, base64Content }) => {
  const response = await mainApi.post("/pdf-file", {
    fileB64: base64Content,
    filename,
  });

  return {
    filename,
    quoteUrl: BACK_BASE_URL + response.data.file,
  };
};

export const downloadPdfWithData = async (postData, inFrame = false) => {
  const pdfDocument = await getPdfDocumentWithData(postData);

  if (inFrame) {
    const pdfAttachment = await getPdfAttachmentFromDocument(pdfDocument);
    const { quoteUrl } = await uploadPdfAttachment(pdfAttachment);

    window.parent.postMessage({ quote: quoteUrl }, "*");

    return { ...pdfDocument, quoteUrl };
  }

  downloadBlob(pdfDocument.blob, pdfDocument.filename);

  return pdfDocument;
};
